'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { ServiceBadge } from '../service-badge/service-badge';

export const PromotedBadge = ({ className = '' }) => {
    return (
        <ServiceBadge
            className={cn(
                'tw-gap-[4px] tw-bg-bcaa-blue-800 tw-flex tw-items-center tw-text-white tw-rounded-[4px]',
                className
            )}
        >
            <span className='tw-text-[12px] tw-font-[700]'>Promoted</span>
        </ServiceBadge>
    );
};

PromotedBadge.propTypes = {
    className: PropTypes.string
};
